<template>
  <div class="container">
    <div class="handle-box">
      <el-form ref="queryCondition" label-width="140px" :model="queryCondition" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('storeFeedback.feedbackNo')" prop="feedbackNo">
                  <el-input class="handle-input" v-model.trim="queryCondition.feedbackNo" clearable placeholder="单据编号" style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('storeFeedback.storeNo')" prop="storeNo">
                  <el-input class="handle-input" v-model.trim="queryCondition.storeNo" clearable placeholder="餐厅国际编号" style="width:100%">
                    <el-divider slot="suffix" direction="vertical"></el-divider>
                    <i class="el-icon-search el-input_icon pointerCss" slot="suffix" @click="showSelStoreDialogMethod('no')"></i>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('storeFeedback.storeName')" prop="storeName">
                  <el-input class="handle-input" v-model.trim="queryCondition.storeName" clearable placeholder="餐厅名称" style="width:100%">
                    <el-divider slot="suffix" direction="vertical"></el-divider>
                    <i class="el-icon-search el-input_icon pointerCss" slot="suffix" @click="showSelStoreDialogMethod('name')"></i>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('storeFeedback.creator')" prop="createName">
                  <el-input class="handle-input" v-model.trim="queryCondition.createName" clearable placeholder="填表人" style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.dcName')" prop="dcName">
                    <el-input class="handle-input" v-model="queryCondition.dcName" clearable placeholder="发货DC" style="width:100%">
                      <el-divider slot="suffix" direction="vertical"></el-divider>
                      <i class="el-icon-search el-input_icon pointerCss" slot="suffix" @click="showSelDcDialogMethod"></i>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.supplier')" prop="supplierName">
                    <el-input class="handle-input" v-model="queryCondition.supplierName" clearable style="width:100%">
                      <el-divider slot="suffix" direction="vertical"></el-divider>
                      <i class="el-icon-search el-input_icon pointerCss" slot="suffix" @click="showSelSupplierDialog=true"></i>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.materialName')" prop="materialName">
                    <el-input class="handle-input" v-model="queryCondition.materialName" clearable placeholder="产品名称" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.feedbackChannel')" prop="sourceCode">
                    <ic-select clearable table="TT_FEEDBACK" class="handle-input" field="QUERY_SOURCE_CODE" v-model="queryCondition.sourceCode" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.status')" prop="processNode">
                    <ic-select clearable :excludes="excludesValue" table="TT_FEEDBACK" class="handle-input" :field="fieldValue" v-model="queryCondition.processNode" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.problemLevel')" prop="problemLevel">
                    <ic-select clearable table="TT_FEEDBACK_FIRST_CHECK" class="handle-input" field="PROBLEM_LEVEL" v-model="queryCondition.problemLevel" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="6">
                  <el-form-item :label="$t('storeFeedback.finalResponsibleParty')" prop="finalResponsibleParty">
                    <ic-select table='TT_FEEDBACK_REPORT' field='FINAL_RESPONSIBLE_PARTY' class="handle-input" v-model="queryCondition.finalResponsibleParty" clearable style="width:100%"></ic-select>
                  </el-form-item>
                </el-col> -->
                <el-col :span="6">
                  <el-form-item label="Category Level1" prop="categoryLevel1Code">
                    <ic-select table="BASE" filterable field="CATEGORY_LEVEL1" clearable @change="queryCondition.categoryLevel2Code=null" v-model="queryCondition.categoryLevel1Code" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category Level2" prop="categoryLevel2Code">
                    <ic-select table="BASE" filterable :field="queryCondition.categoryLevel1Code" clearable multiple v-model="queryCondition.categoryLevel2Code" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="餐厅提交日期(从)" prop="createDateFrom">
                    <el-date-picker style="width: 100%" v-model="queryCondition.createDateFrom" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="餐厅提交日期(至)" prop="createDateTo">
                    <el-date-picker style="width: 100%" v-model="queryCondition.createDateTo" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="接到反馈日期(从)" prop="commitDateFrom">
                    <el-date-picker style="width: 100%" v-model="queryCondition.commitDateFrom" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="接到反馈日期(至)" prop="commitDateTo">
                    <el-date-picker style="width: 100%" v-model="queryCondition.commitDateTo" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
          <el-button size="mini" type="primary" @click="restQueryFormThis()">{{$t('common.reset')}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button size="mini" class="btn" type="primary" v-acl="FeedbacksNew" v-if="isStoreFbc" @click="addStoreFeedback(-99999)">{{$t('common.addNew')}}</el-button>
      <el-button size="mini" class="btn" type="danger" v-acl="FeedbacksSuspend" v-if="isStoreFbc" @click="stopStoreFeedback">{{$t('common.stop')}}</el-button>
      <el-button size="mini" class="btn" type="primary" v-acl="FeedbacksCopy" v-if="isStoreFbc" @click="copyStoreFeedback">{{$t('common.copy')}}</el-button>
      <el-button size="mini" class="btn" type="primary" v-acl="FeedbacksCreateReport" v-if="isSupplier" @click="createNewReport">{{$t('storeFeedback.report.createReport')}}</el-button>
      <el-button size="mini" class="btn" type="primary" v-acl="FeedbacksExport" @click="exportExcel">{{$t('common.export')}}</el-button>
    </div>
    <el-table :data="tableData" ref="dataTable" @selection-change="handleSelectionChange" border highlight-current-row max-height='420'>
      <el-table-column align="center" fixed width="56" :label="$t('common.select')">
        <template slot-scope="scope">
          <el-radio v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.ttFeedbackId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip fixed min-width="120px" sortable prop="feedbackNo" align="center" :label="$t('storeFeedback.feedbackNo')">
        <template slot-scope="scope">
          <div @click="showDetail(scope.row.ttFeedbackId)" class="a-link">{{scope.row.feedbackNo}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip min-width="160px" sortable prop="supplierName" align="center" :label="$t('storeFeedback.supplier')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="130px" sortable prop="materialName" align="center" :label="$t('storeFeedback.materialName')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="90px" sortable prop="problemLevel" align="center" :label="$t('storeFeedback.problemLevel')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="90px" sortable prop="isRepeat" align="center" :label="$t('storeFeedback.isRepeat')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="110px" sortable prop="createDate" align="center" :label="$t('storeFeedback.createDate')">
        <template slot-scope="scope">
          {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip min-width="130px" sortable prop="storeName" align="center" :label="$t('storeFeedback.storeName')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="110px" sortable prop="processNode" align="center" :label="$t('storeFeedback.status')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="90px" sortable prop="consumeTypeI18n" align="center" :label="$t('storeFeedback.consumeType')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="100px" sortable prop="productionDate" align="center" :label="$t('storeFeedback.productDate')">
        <template slot-scope="scope">
          {{scope.row.productionDate | dateFormatFilter("YYYY-MM-DD")}}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip min-width="90px" sortable prop="dcName" align="center" :label="$t('storeFeedback.dcName')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="90px" sortable prop="materialCode" align="center" :label="$t('storeFeedback.materialCode')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="140px" sortable prop="categoryLevel2Name" align="center" label="Category Level2"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="90px" sortable prop="sourceCodeI18n" align="center" :label="$t('storeFeedback.feedbackChannel')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="90px" sortable prop="reportTypeI18n" align="center" :label="$t('storeFeedback.reportType')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="160px" sortable prop="storeNo" align="center" :label="$t('storeFeedback.storeNo')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="90px" sortable prop="isDirectSaleI18n" align="center" :label="$t('storeFeedback.isDirectSale')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="90px" sortable prop="createName" align="center" :label="$t('storeFeedback.creator')"></el-table-column>
      <el-table-column show-overflow-tooltip min-width="90px" sortable prop="auditor" align="center" :label="$t('storeFeedback.auditor')"></el-table-column>
    </el-table>
    <div class="pagination">
      <!--===分页组件===-->
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <plant-sel-page ref="supplierSelRef" :multipleSelectionFlag="false" @subCallMethod="selectSupplierMethod"></plant-sel-page>
    </el-dialog>

    <el-dialog :visible.sync="showSelStoreDialog" append-to-body width="80%">
      <SelStore ref="selectStoreRef" :multipleSelectionFlag="false" @subCallMethod="selectStoreMethod"></SelStore>
    </el-dialog>

    <el-dialog :visible.sync="showSelDcDialog" append-to-body width="80%">
      <SelDc ref="selectDcRef" :multipleSelectionFlag="false" :disabledStatusFlag="false" :type="new Array('DC','DIRECT_SUPPLIER')" @subCallMethod="selectDcMethod"></SelDc>
    </el-dialog>

    <el-dialog :visible.sync="showSelMaterialDialog" append-to-body width="80%">
      <SelMaterial ref="selectMaterialRef" :multipleSelectionFlag="false" @subCallMethod="selectMaterialMethod"></SelMaterial>
    </el-dialog>

  </div>
</template>
<script>
import storeFeedbackApi from "@/api/storeFeedback/storeFeedback";
import commonFun from "@/utils/commonFun";
import reportApi from "@/api/storeFeedback/report";
import PickupUser from "@/components/common/pickupUser";
import { Message } from "element-ui";
import commonFunction from "@/utils/dataTableUtils";
import SelSupplier from '@/components/page/base-data/supplier-sel-page';
import SelStore from '@/components/page/base-data/store-sel-page';
import SelDc from '@/components/page/base-data/dc-sel-page'
import SelMaterial from '@/components/page/base-data/material-sel-page'
import IcSelect from "@/components/common/icSelect";
import { inputChoiceService } from "@/api/common/input-choice";
import PlantSelPage from "@/components/page/base-data/plant-sel-page";
import paginationMixin from '@/mixins/pagitionMixin';
import store from '@/store/index'
export default {
  name: "fixedPointStoreFeedback",
  components: { PlantSelPage, IcSelect, PickupUser, SelSupplier, SelStore, SelDc, SelMaterial },
  mixins: [paginationMixin],
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      totalCount: 0,
      isSupplier: false,//是否供应商
      isStoreFbc: false,//是否门店和fbc
      radioVal: null,
      selectRow: null,
      showSelSupplierDialog: false,
      showSelStoreDialog: false,
      showSelDcDialog: false,
      showSelMaterialDialog: false,
      activeName: 'first',
      storeType: '',
      queryCondition: {
        pageNum: 1, //当前页
        pageSize: 15, //每页多少条
        feedbackNo: null,
        storeNo: null,
        storeName: null,
        createName: null,
        dcName: null,
        supplierName: null,
        supplierCode: null,
        materialCode: null,
        materialName: null,
        sourceCode: null,
        consumeType: null,
        isDirectSale: null,
        processNode: null,
        querySupplierId: null,
        auditor: '',
        categoryLevel1Code: null,
        categoryLevel2Code: null,
        createDateFrom: '',
        createDateTo: '',
        commitDateFrom: '',
        commitDateTo: ''
      },
      tableData: [],
      sourcing: {},
      multipleSelection: [],
      fieldValue: 'OTHER_PROCESS_NODE',
      emplFlag: '',
      excludesValue: '',
      isFBC: false,
      isStore: false,
    };
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    storeFeedbackApi.list(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  created() {
    // this.getInputChoiceValues();
    // this.queryData(1);
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    //用户所属系统
    this.emplFlag = localStorage.getItem('ms_emplFlag');
    if (this.emplFlag == 'SUP') {
      this.excludesValue = ['store', 'fbcHandle'];
    }
    //门店      SF_STORE_BASIC
    //反馈中心  SF_FBC_BASIC
    //麦当劳   SF_MCD_BASIC
    //供应商  SF_SUP_BASIC
    for (let i = 0, len = roles.length; i < len; i++) {
      if (roles[i] == 'SF_SUP_BASIC') {//供应商
        this.isSupplier = true;
      }
      if (roles[i] == 'SF_STORE_BASIC') {//门店
        this.isStoreFbc = true;
        this.isStore = true;
      }
      if (roles[i] == 'SF_FBC_BASIC') {//反馈中心
        this.isStoreFbc = true;
        this.isFBC = true;
      }
      if (roles[i] == 'SF_MCD_BASIC') {//麦当劳
        //this.excludesValue = ['store', 'fbcHandle'];
      }
    }
    if (!!roles) {
      if (roles.indexOf('SF_MCD_BASIC') != -1 || roles.indexOf('SF_FBC_BASIC') != -1 || roles.indexOf('SF_SUP_BASIC') != -1) {
        //非门店用户
      } else if (roles.indexOf('SF_STORE_BASIC') != -1) {
        //门店用户
        this.fieldValue = 'STORE_PROCESS_NODE';
      } else {
        //非门店用户
      }
    }
  },
  methods: {
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_FEEDBACK:STORE_PROCESS_NODE"] = "TT_FEEDBACK:STORE_PROCESS_NODE";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        console.log(res["TT_FEEDBACK:STORE_PROCESS_NODE"])
      });
    },
    showSelStoreDialogMethod: function (type) {
      this.storeType = type;
      this.showSelStoreDialog = true;
      if (this.$refs.selectStoreRef != undefined) {
        this.$refs.selectStoreRef.cancelSeleted();
      }
    },
    selectStoreMethod: function (storeList) {
      if (this.storeType == 'no') {
        if (!!storeList && storeList.length > 0) {
          this.queryCondition.storeNo = storeList[0].storeNo;
        } else {
          this.queryCondition.storeNo = '';
        }
      } else {
        if (!!storeList && storeList.length > 0) {
          this.queryCondition.storeName = storeList[0].storeName;
        } else {
          this.queryCondition.storeName = '';
        }
      }
      this.showSelStoreDialog = false;
    },
    showSelDcDialogMethod: function () {
      this.showSelDcDialog = true;
      if (this.$refs.selectDcRef != undefined) {
        this.$refs.selectDcRef.cancelSeleted();
      }
    },
    //到货仓库选择
    selectDcMethod: function (dc) {
      // this.queryCondition.dcName = dc.value;
      if (!!dc && dc.length > 0) {
        this.queryCondition.dcName = dc[0].dcName;
      } else {
        this.queryCondition.dcName = '';
      }
      this.showSelDcDialog = false;
    },
    //产品
    selectMaterialMethod: function (materialList) {
      if (!!materialList && materialList.length > 0) {
        this.queryCondition.materialCode = materialList[0].eightBitCode;
      } else {
        this.queryCondition.materialCode = '';
      }
      this.showSelMaterialDialog = false;
    },

    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      storeFeedbackApi.list(this.queryCondition).then(resp => {
        if (commonFun.isNotEmpty(resp.resultData)) {
          this.tableData = resp.resultData;
        } else {
          this.tableData = []
        }
        this.totalCount = resp.totalCount;
      })
    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRow = [];
      this.selectRow = row;
    },
    showDetail(id) {
      if (this.actionCheck.actionCheck('FeedbacksInit') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      let that = this;

      let resolve = that.$router.resolve({
        path: `/storeFeedback-detail`,
        query: {
          feedbackId: id
        }
      });
      window.open(resolve.href, "_blank");
    },
    addStoreFeedback(id) {
      this.$router.push({
        path: `/storeFeedback-detail`,
        query: {
          feedbackId: id
        }
      });
    },
    createNewReport() {
      if (this.selectRow == null) {
        Message({ message: this.$t('common.pleaseSelectOneData'), type: "warning" });
      } else {
        if (this.selectRow.status == 'suspend') {
          Message({ message: this.$t('storeFeedback.report.AlreadySuspend'), type: "warning" });
          return;
        }
        reportApi.haveFinalReport(this.selectRow.ttFeedbackId).then(resp => {
          if (!resp.data) {
            this.$router.push({
              name: "createfeedbackReport",
              query: {
                feedbackId: this.selectRow.ttFeedbackId,
                action: 'create'
              }
            })
          } else {
            Message({ message: this.$t('storeFeedback.report.AlreadyFinalReport'), type: "warning" });
          }
        });

      }

    },
    handleSizeChange(e) {
      this.page.size = e;
    },
    handleCurrentChange(e) {
      this.page.current = e;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectSupplierMethod: function (supList) {
      //this.queryCondition.querySupplierId = supList[0].tmSupplierId;
      //this.queryCondition.supplierCode = supList[0].supplierName;
      this.queryCondition.supplierName = supList[0].supplierName;
      this.showSelSupplierDialog = false;
    },
    stopStoreFeedback: function () {
      let that = this;
      if (this.selectRow == null) {
        //请选择需要中止的反馈单
        Message({ message: this.$t('storeFeedback.selectSuspendFeedback'), type: "warning" });
      } else {
        console.log(this.selectRow)
        let delId = this.selectRow.ttFeedbackId;
        //如果是门店
        if (that.isStore) {
          //如果为草稿
          if (that.selectRow.status == 'draft' || that.selectRow.status == 'return') {
            that.$prompt(that.$t("storeFeedback.report.pleaseReason"), this.$t('common.tips'), {
              confirmButtonText: that.$t("common.confirm"),
              cancelButtonText: that.$t("common.cancel"),
              customClass: 'colorBtn',
              inputValidator: (val) => {
                if (val === null) {
                  return that.$t('sensory.report.ReasonCannotEmpty');
                }
                return val.length <= 300
              },
              inputErrorMessage: that.$t("sensory.report.reasonTooLong")
            })
              .then(msg => {
                if (commonFun.isEmpty(msg.value)) {
                  that.$t('sensory.report.ReasonCannotEmpty');
                  return;
                }
                storeFeedbackApi.suspendFeedBack(delId, msg.value).then((res) => {
                  if (res.meta.success) {
                    this.selectRow = null;
                    this.radioVal = null;
                    Message({ message: this.$t('common.operateSuccess'), type: "success" });
                    this.queryData();
                  } else {
                    Message({ message: this.$t('common.operateError'), type: "error" });
                  }
                });
              })
              .catch(() => {
              });
          } else {
            Message({ message: '此状态不可以中止', type: "error" });
          }
        }
        //如果是反馈中心
        if (that.isFBC) {
          //已经中止
          if (that.selectRow.status == 'suspend') {
            Message({ message: '此状态不可以中止', type: "error" });
          }
          //中止时填原因
          if (that.selectRow.status != 'suspend') {
            that.$prompt(that.$t("storeFeedback.report.pleaseReason"), this.$t('common.tips'), {
              confirmButtonText: that.$t("common.confirm"),
              cancelButtonText: that.$t("common.cancel"),
              customClass: 'colorBtn',
              inputValidator: (val) => {
                if (val === null) {
                  return that.$t('sensory.report.ReasonCannotEmpty');
                }
                return val.length <= 300
              },
              inputErrorMessage: that.$t("sensory.report.reasonTooLong")
            })
              .then(msg => {
                if (commonFun.isEmpty(msg.value)) {
                  that.$t('sensory.report.ReasonCannotEmpty');
                  return;
                }
                storeFeedbackApi.suspendFeedBack(delId, msg.value).then((res) => {
                  if (res.meta.success) {
                    this.selectRow = null;
                    this.radioVal = null;
                    Message({ message: this.$t('common.operateSuccess'), type: "success" });
                    this.queryData();
                  } else {
                    Message({ message: this.$t('common.operateError'), type: "error" });
                  }
                });
              })
              .catch(() => {
              });
          }

        }

      }
    },
    copyStoreFeedback: function () {
      if (this.selectRow == null) {
        //请选择需要复制创建的反馈单
        Message({ message: this.$t('storeFeedback.selectCopyFeedback'), type: "warning" });
      } else {
        let copyId = this.selectRow.ttFeedbackId;

        //请确认是否复制创建!
        this.$confirm(this.$t('common.copyConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          customClass: 'colorBtn',
          type: 'warning'
        }).then(() => {
          storeFeedbackApi.copyFeedBack(copyId).then((res) => {
            console.info(res.meta.success);
            if (res.meta.success) {
              this.selectRow = null;
              this.radioVal = null;
              Message({ message: this.$t('common.operateSuccess'), type: "success" });
              this.queryData();
              this.showDetail(res.data);
            } else {
              Message({ message: this.$t('common.operateError'), type: "error" });
            }
          });
        }).catch(() => {

        });
      }
    },
    restQueryFormThis: function () {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition.querySupplierId = null;
      this.queryCondition = {
        pageNum: 1, //当前页
        pageSize: 15, //每页多少条
        feedbackNo: null,
        storeNo: null,
        storeName: null,
        createName: null,
        dcName: null,
        supplierName: null,
        supplierCode: null,
        materialCode: null,
        materialName: null,
        sourceCode: null,
        consumeType: null,
        isDirectSale: null,
        processNode: null,
        querySupplierId: null,
        auditor: '',
        categoryLevel1Code: null,
        categoryLevel2Code: null,
        createDateFrom: '',
        createDateTo: '',
        commitDateFrom: '',
        commitDateTo: ''
      }
      this.queryData();
    },
    exportExcel: function () {
      storeFeedbackApi.exportFeedbackList(this.queryCondition);
    },
  },
  extends: commonFunction,
};
</script>
<style scoped lang="scss">
.fixedPointStoreFeedback {
  .toolsBox {
    margin-bottom: 10px;
  }
}

.pointerCss {
  cursor: pointer;
}
</style>
<style>
.colorBtn .el-button {
  background: #f8ab01 !important;
  color: #fff !important;
  border-color: #f8ab01 !important;
}
</style>
